import translations from './palladium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/palladium'

export const palladium: Metal = {
  id: 19,
  slug: 'palladium',
  name: t.name,
  symbol: 'Pd',
  mines: [
    {
      name: 'Norilsk-Talnakh (Russia, Nornickel — Arctic Circle)',
      region: 'Norilsk-Talnakh',
      coordinates: [88.2, 69.33],
    },
    {
      name: 'Bushveld Complex: Impala Rustenburg & Anglo American Platinum (South Africa)',
      region: 'Bushveld Complex',
      coordinates: [27.24, -25.67],
    },
    {
      name: 'Stillwater (USA, Montana, Sibanye-Stillwater — only primary PGM mine in the US)',
      region: 'Stillwater',
      coordinates: [-109.87, 45.6],
    },
  ],
  countries: [
    { name: 'Russia', percent: 39.5 },
    { name: 'South Africa', percent: 37.9 },
    { name: 'Canada', percent: 7.9 },
    { name: 'Zimbabwe', percent: 7.9 },
    { name: 'USA', percent: 4.2 },
  ],
  related: ['platinum', 'ruthenium', 'copper', 'nickel'],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 4, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 4, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 4, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
    },
  },
}
